import { getVehicleHasProvinceByVehicleIdRequest } from "../../data/vehicleHasProvinceApi";

function getPayloadData(response) {
  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  if (Array.isArray(response?.data?.data)) {
    return response.data.data;
  }

  return [];
}

export async function getVehicleHasProvinceByVehicleIdUseCase(vehicleId) {
  if (!vehicleId) {
    throw new Error("El id del vehiculo es obligatorio.");
  }

  return getPayloadData(
    await getVehicleHasProvinceByVehicleIdRequest(vehicleId),
  );
}
